import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    IconButton,
    Menu,
    MenuItem,
    Checkbox,
    Typography,
    Button,
    TextField,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

import SideNav from '../../common/SideNav';
import RuleEditor from '../../common/RuleEditor';
import ConfirmDialog from '../../common/ConfirmDialog';
import {
    hasSideBar,
    setCurrentRuleId,
    setCurrentRuleName,
    toggleSideBar,
    updateCurrentComponent,
} from '../../../store/actions/navActions';
import {
    hideLoading,
    showLoading,
} from '../../../store/actions/loadingActions';
import {
    notify,
    notifyError,
    notifySuccess,
} from '../../../store/actions/notificationActions';
// import { getRuleList } from '../../../services/api/ruleApi';
import {
    extractEvent,
    extractEventAttribute,
} from '../../../services/ruleUtils';
import {
    asString,
    capitalizeFirstLetter,
    nonEmptyString,
    toUpperCase,
} from '../../../services/typeUtils';
import { formatDate, formatDateTime } from '../../../services/formatUtils';
import { Email } from '../../../services/Email';
import * as C from '../../../services/constants';
import {
    createRule,
    deleteRule,
    getRule,
    getRuleList,
    mannualTriggerRule,
    updateRule,
    updateRuleStatus,
    // testRule,
} from '../../../services/api/nbaApi';
import { countBy } from 'lodash';
import CustomMuiTable from './CustomMuiTable';

// ...existing imports...

const manageRulesTableHeader = {
    status: 'Status',
    nbaRuleId: 'Rule Id',
    // ruleAppliesTo: 'Rule Id',
    // subcategory: 'Subcategory',
    ruleName: 'Rule Name',
    frequency: 'Frequency',
    loadType: 'Load Type',
    nextRun: 'Next Run(UTC Time)',
    json: 'Rule JSON',
    actions: 'Actions',
};
const filterColumns = ["status", "nbaRuleId", "ruleName", "frequency", "loadType", "nextRun", "json"];

// const statusOptions = ['activee', 'inactive'];
// const statusOptions = ['active', 'inactive'];
const statusOptions = ['published', 'draft', 'expired'];
const ruleAppliesToOptions = [
    'consumer',
    'article',
    'game',
    'video',
    'quiz',
    'raffle',
    'user tier',
];

const CollapsibleJSON = ({ query }) => {
    const [expanded, setExpanded] = React.useState(false);

    const toggleExpanded = () => setExpanded((prev) => !prev);

    return (
        <Box
            sx={{
                wordWrap: 'break-word',
                border: '1px solid #ccc',
                borderRadius: 4,
                padding: 1,
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <Typography
                variant="body2"
                component="div"
                sx={{
                    maxWidth: 300,
                    maxHeight: expanded ? 'none' : '1.5em',
                    overflow: expanded ? 'visible' : 'hidden',
                    textOverflow: expanded ? 'clip' : 'ellipsis',
                    whiteSpace: expanded ? 'normal' : 'nowrap',
                }}
            >
                {query}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'end',
                }}
            >
                <Button
                    size="small"
                    variant="text"
                    onClick={toggleExpanded}
                    sx={{ textTransform: 'none', width: '80px' }}
                >
                    {expanded ? 'Show Less' : 'Show More'}
                </Button>
            </Box>
        </Box>
    );
};

const ManageRules = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const fields = Object.keys(manageRulesTableHeader);
    const { market, category, brand } = useSelector((state) => state.auth.user);

    const [holdDataForSearch, setHoldDataForSearch] = useState([]);
    const [rules, setRules] = useState([]);
    const [ruleId, setRuleId] = useState(null);
    const [showRuleEditor, setShowRuleEditor] = useState(false);
    const [type, setType] = useState(C.RULE_TYPE_NEW);
    const [page, setPage] = useState(0);
    // const [sortBy, setSortBy] = useState('status');
    const [sortBy, setSortBy] = useState('nbaRuleId');
    // const [sortOrder, setSortOrder] = useState('asc');
    const [sortOrder, setSortOrder] = useState('desc');

    const [filterStatus, setFilterStatus] = useState([]);
    const [filterRuleAppliesTo, setFilterRuleAppliesTo] = useState([]);
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [anchorElRuleAppliesTo, setAnchorElRuleAppliesTo] = useState(null);
    const [jsonSearch, setJsonSearch] = useState('');
    const [confirmDialog, setConfirmDialog] = useState({
        display: false,
        title: '',
        message: '',
        note: '',
        onClose: null,
        onConfirm: null,
        confirmText: '',
        backText: '',
    });

    //      const dummyRules = [
    //     {
    //         nbaRuleId: '1',
    //         status: 'active',
    //         ruleAppliesTo: 'consumer',
    //         ruleType: 'type1',
    //         description: 'Send daily summary email to all consumers.',
    //         subcategory: 'p1',
    //         frequency: 'daily',
    //         loadType: 'full',
    //         nextRun: '2025-08-26',
    //         sqlQuery: 'SELECT * FROM users WHERE subscribed = 1;',
    //     },
    //     {
    //         nbaRuleId: '2',
    //         status: 'inactive',
    //         ruleAppliesTo: 'article',
    //         ruleType: 'type2',
    //         description: 'Weekly article engagement report.',
    //         subcategory: 'p2',
    //         frequency: 'weekly',
    //         loadType: 'delta',
    //         nextRun: '2025-08-31',
    //         sqlQuery: 'SELECT article_id, COUNT(*) FROM article_views GROUP BY article_id;',
    //     },
    //     {
    //         nbaRuleId: '3',
    //         status: 'active',
    //         ruleAppliesTo: 'quiz',
    //         ruleType: 'type3',
    //         description: 'Monthly quiz participation stats.',
    //         subcategory: 'p3',
    //         frequency: 'monthly',
    //         loadType: 'full',
    //         nextRun: '2025-09-01',
    //         sqlQuery: 'SELECT quiz_id, COUNT(*) FROM quiz_attempts GROUP BY quiz_id;',
    //     },
    // ];
    useEffect(() => {
        if (searchParams?.get('page') === 'add') {
            openRuleEditor();
        }
    }, []);
    const handlePageChange = (event, page) => {
        setPage(page);
    };

    const openRuleEditor = (status, ruleId = null) => {
        setRuleId(ruleId);
        setType(status);
        setShowRuleEditor(true);
    };

    const closeRuleEditor = () => {
        setRuleId(null);
        setShowRuleEditor(false);
    };

    useEffect(() => {
        // setHoldDataForSearch(existingRules);
        // setRules(existingRules);

        dispatch(updateCurrentComponent(C.APP_MANAGE_RULES_PAGE_TITLE));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));

        dispatch(showLoading());

        getRuleList(market, brand)
            .then((response) => {
                //console.log('API response:', response.data);

                const existingRules = response.data.map((rule) => ({
                    nbaRuleId: rule.nbaRuleId,
                    status: rule.status,
                    // : asString(rule.nbaRuleId),
                    ruleType: rule.namespace,
                    ruleName: rule.description.toUpperCase(),
                    frequency: rule.schedule?.frequency || '-',
                    loadType: rule.schedule?.loadType || '-',
                    nextRun:(rule.status === 'DRAFT' || rule.status === 'EXPIRED')
                            ? '-'
                            : (rule.schedule?.nextRun ? (rule.schedule.nextRun)
                            : '-'),
                    json: rule.condition,
                }));

                setHoldDataForSearch(existingRules);
                setRules(existingRules);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(hideLoading()));
    }, [showRuleEditor]);

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(field);
            setSortOrder('asc');
        }
    };

    const handleFilterStatus = (event) => {
        const { checked, value } = event.target;
        setFilterStatus((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    const handleFilterRuleAppliesTo = (event) => {
        const { checked, value } = event.target;
        setFilterRuleAppliesTo((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    // const filteredAndSortedRules = rules
    //     .filter((rule) => {
    //         return (
    //             filterStatus.length === 0 ||
    //             filterStatus.includes(rule.status.toLowerCase())
    //         );
    //     })
    //     .filter((rule) => {
    //         return (
    //             filterRuleAppliesTo.length === 0 ||
    //             filterRuleAppliesTo.includes(rule.ruleAppliesTo.toLowerCase())
    //         );
    //     })
    //     .sort((a, b) => {
    //         if (sortOrder === 'asc') {
    //             return a[sortBy].toLowerCase() > b[sortBy].toLowerCase()
    //                 ? 1
    //                 : -1;
    //         }
    //         return a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
    //     });

    const filteredAndSortedRules = rules
        .filter((rule) => {
            return (
                filterStatus.length === 0 ||
                filterStatus.includes(rule.status.toLowerCase())
            );
        })
        .sort((a, b) => {
            // Handle numeric sorting for nbaRuleId
            if (sortBy === 'nbaRuleId') {
                const aId = parseInt(a.nbaRuleId);
                const bId = parseInt(b.nbaRuleId);
                return sortOrder === 'asc' ? aId - bId : bId - aId;
            }

            // Handle string sorting for other fields
            if (sortOrder === 'asc') {
                return a[sortBy].toLowerCase() > b[sortBy].toLowerCase()
                    ? 1
                    : -1;
            }
            return a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
        });

    //mycode from here

    const handleEdit = (rule) => {
        // openRuleEditor(C.RULE_TYPE_PUBLISHED, rule.nbaRuleId);
        openRuleEditor(C.RULE_TYPE_DRAFT, rule.nbaRuleId);
    };

    // const handleExpireOrPublish = (rule) => {
    //     dispatch(showLoading());

    //     const newStatus =
    //         rule.status === C.RULE_TYPE_EXPIRED ? 'PUBLISHED' : 'EXPIRED';

    //     updateRuleStatus(market, brand, rule.nbaRuleId, newStatus)
    //         .then(() => {
    //             // Use constants for local state update to match UI expectations
    //             const newStatusConstant =
    //                 newStatus === 'PUBLISHED'
    //                     ? C.RULE_TYPE_PUBLISHED
    //                     : C.RULE_TYPE_EXPIRED;

    //             setRules((prevRules) =>
    //                 prevRules.map((r) =>
    //                     r.nbaRuleId === rule.nbaRuleId
    //                         ? { ...r, status: newStatusConstant }
    //                         : r
    //                 )
    //             );
    //             setHoldDataForSearch((prevRules) =>
    //                 prevRules.map((r) =>
    //                     r.nbaRuleId === rule.nbaRuleId
    //                         ? { ...r, status: newStatusConstant }
    //                         : r
    //                 )
    //             );
    //             dispatch(
    //                 notifySuccess(
    //                     newStatus === 'PUBLISHED' ? 'Published!' : 'Expired!',
    //                     `Rule has been successfully ${newStatus.toLowerCase()}.`
    //                 )
    //             );
    //         })
    //         .catch((error) => {
    //             console.error('Status update error:', error);
    //             dispatch(
    //                 notifyError('Error!', 'Unable to update rule status.')
    //             );
    //         })
    //         .finally(() => dispatch(hideLoading()));
    // };

    const handleExpireOrPublish = (rule) => {
        // Early return if trying to publish an expired rule
        if (rule.status === C.RULE_TYPE_EXPIRED) {
            dispatch(
                notifyError(
                    'Cannot Publish!',
                    'Expired rules cannot be published.'
                )
            );
            return;
        }

        // Early return if trying to expire a draft rule
        if (rule.status === C.RULE_TYPE_DRAFT) {
            dispatch(
                notifyError('Cannot Expire!', 'Draft rules cannot be expired.')
            );
            return;
        }
        setConfirmDialog({
            display: true,
            title: 'Confirm: Expire Rule!',
            message: 'Are you sure you want to expire this rule?',
            note: 'Once you expire this rule will no longer be triggered or be re-activated.',
            onConfirm: () => expireRule(rule),
            onClose: closeConfirmDialog,
            confirmText: 'Yes, Expire Rule',
            backText: 'No, Do Not Expire',
        });
    };
    //dispatch(showLoading());

    // Only published rules can be expired
    // const newStatus = 'EXPIRED';

    //     updateRuleStatus(market, brand, rule.nbaRuleId, newStatus)
    //         .then(() => {
    //             setRules((prevRules) =>
    //                 prevRules.map((r) =>
    //                     r.nbaRuleId === rule.nbaRuleId
    //                         ? { ...r, status: C.RULE_TYPE_EXPIRED }
    //                         : r
    //                 )
    //             );
    //             setHoldDataForSearch((prevRules) =>
    //                 prevRules.map((r) =>
    //                     r.nbaRuleId === rule.nbaRuleId
    //                         ? { ...r, status: C.RULE_TYPE_EXPIRED }
    //                         : r
    //                 )
    //             );
    //             dispatch(
    //                 notifySuccess(
    //                     'Expired!',
    //                     'Rule has been successfully expired.'
    //                 )
    //             );
    //         })
    //         .catch((error) => {
    //             console.error('Status update error:', error);
    //             dispatch(
    //                 notifyError('Error!', 'Unable to update rule status.')
    //             );
    //         })
    //         .finally(() => dispatch(hideLoading()));
    // };

    const handleDelete = (rule) => {
        console.log('Attempting to delete rule:', rule);

        if (
            rule.status === C.RULE_TYPE_PUBLISHED ||
            rule.status === C.RULE_TYPE_EXPIRED
        ) {
            dispatch(
                notifyError(
                    'Cannot Delete!',
                    'Published and expired rules cannot be deleted.'
                )
            );
            return;
        }

        setConfirmDialog({
            display: true,
            title: 'Confirm: Delete Rule',
            message: 'Are you sure you want to delete this rule?',
            note: 'This action cannot be undone.',
            onConfirm: () => removeRule(rule),
            onClose: closeConfirmDialog,
            confirmText: 'Yes, Delete Rule',
            backText: 'No, Continue',
        });
    };

    const expireRule = (rule) => {
        dispatch(showLoading());
        const newStatus = 'EXPIRED';

        updateRuleStatus(market, brand, rule.nbaRuleId, newStatus)
            .then(() => {
                setRules((prevRules) =>
                    prevRules.map((r) =>
                        r.nbaRuleId === rule.nbaRuleId
                            ? { ...r, status: C.RULE_TYPE_EXPIRED }
                            : r
                    )
                );
                setHoldDataForSearch((prevRules) =>
                    prevRules.map((r) =>
                        r.nbaRuleId === rule.nbaRuleId
                            ? { ...r, status: C.RULE_TYPE_EXPIRED }
                            : r
                    )
                );
                dispatch(
                    notifySuccess(
                        'Expired!',
                        'Rule has been successfully expired.'
                    )
                );
                closeConfirmDialog();
            })
            .catch((error) => {
                console.error('Status update error:', error);
                dispatch(
                    notifyError('Error!', 'Unable to update rule status.')
                );
            })
            .finally(() => dispatch(hideLoading()));
    };

    const removeRule = (rule) => {
        console.log('Deleting rule:', rule);
        dispatch(showLoading());
        // deleteRule(market, rule.nbaRuleId)
        deleteRule(market, brand, rule.nbaRuleId)
            .then((response) => {
                setRules((prevRules) =>
                    prevRules.filter((r) => r.nbaRuleId !== rule.nbaRuleId)
                );
                dispatch(
                    notify(
                        'Deleted Rule!',
                        'Rule has been successfully deleted.'
                    )
                );
                closeConfirmDialog();
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to delete rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    };

    const closeConfirmDialog = () => {
        setConfirmDialog({ ...confirmDialog, display: false });
    };

    const handleManualTrigger = (rule) => {
        dispatch(showLoading());
        const triggerBody = {
            ruleId: rule?.nbaRuleId,
            country: market,
            brand: brand,
            ruleName: rule?.description,
        };

        mannualTriggerRule(market, brand, triggerBody)
            .then((response) => {
                if (response && response?.success) {
                    const resultS3Path = response?.data?.baseS3Path;
                    if (resultS3Path) {
                        dispatch(
                            notify(
                                'Success!',
                                `Rule triggered successfully.`
                            )
                        );
                    }
                    else if(response?.message){
                        dispatch(notify(
                            '',
                            response?.message
                        ));
                    }
                    else {
                        dispatch(
                            notifyError('Error!', 'Unable to trigger the rule.')
                        );
                    }
                } else {
                    dispatch(
                        notifyError('Error!', 'Unable to trigger the rule.')
                    );
                }
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to trigger the rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    };

    //my code till here

    const renderFieldContent = (field, rule) => {
        if (field === C.RULE_PROPERTY_STATUS) {
            switch (rule[field]) {
                case C.RULE_TYPE_PUBLISHED:
                    return (
                        <span
                            className="view-rule published"
                            onClick={() =>
                                rule.ruleType !== C.RULE_FOR_TIER &&
                                openRuleEditor(
                                    C.RULE_TYPE_PUBLISHED,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Published
                        </span>
                    );
                case C.RULE_TYPE_DRAFT:
                    return (
                        <span
                            className="view-rule draft"
                            onClick={() =>
                                openRuleEditor(
                                    C.RULE_TYPE_DRAFT,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Draft
                        </span>
                    );

                case C.RULE_TYPE_EXPIRED:
                    return (
                        <span
                            className="view-rule expired"
                            onClick={() =>
                                openRuleEditor(
                                    C.RULE_TYPE_EXPIRED,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Expired
                        </span>
                    );
                default:
                    return '-';
                //         }
                // }

                // case C.RULE_TYPE_ACTIVE:
                //     return (
                //         <span
                //             className="view-rule published"

                //             onClick={() =>
                //                 rule.ruleType !== C.RULE_FOR_TIER &&
                //                 openRuleEditor(
                //                     C.RULE_TYPE_ACTIVE,
                //                     rule.nbaRuleId
                //                 )
                //             }
                //         >
                //             Active
                //         </span>
                //     );
                // case C.RULE_TYPE_INACTIVE:
                //     return (
                //         <span
                //             className="view-rule draft"
                //             onClick={() =>
                //                 openRuleEditor(
                //                     C.RULE_TYPE_INACTIVE,
                //                     rule.nbaRuleId
                //                 )
                //             }
                //         >
                //             Inactive
                //         </span>
                //     );
                // default:
                //     return '-';
            }
        } else if (field === C.RULE_PROPERTY_PUBLISHED_DATE) {
            if (rule[C.RULE_PROPERTY_STATUS] === C.RULE_TYPE_PUBLISHED) {
                return nonEmptyString(rule[field]) && rule[field];
            } else {
                return '-';
            }
        } else if (field === C.RULE_PROPERTY_NEXT_RUN_DATE) {
            return formatDateTime(rule[field]);
        }else if (field === C.RULE_PROPERTY_JSON) {
            return <CollapsibleJSON key={rule.nbaRuleId} query={rule[field]} />;
        } else if (nonEmptyString(rule[field])) {
            return rule[field];
        } else if ((rule[field])) {
            return rule[field];
        } else if (field === C.RULE_PROPERTY_ACTIONS || field === 'actions') {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '8px',
                    }}
                >
                    <Button
                        className={`publish-rule active`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleManualTrigger(rule)}
                        disabled={
                            rule.status === C.RULE_TYPE_EXPIRED ||
                            rule.status === C.RULE_TYPE_DRAFT
                        }
                    >
                        Manual Trigger
                    </Button>

                    <Button
                        className={`save-rule ${
                            rule.status === C.RULE_TYPE_DRAFT
                                ? 'active'
                                : 'inactive'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleEdit(rule)}
                        disabled={rule.status !== C.RULE_TYPE_DRAFT}
                    >
                        Edit
                    </Button>

                    <Button
                        className={`save-rule ${
                            rule.status === C.RULE_TYPE_DRAFT
                                ? 'inactive'
                                : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleExpireOrPublish(rule)}
                        disabled={
                            rule.status === C.RULE_TYPE_DRAFT ||
                            rule.status === C.RULE_TYPE_EXPIRED
                        }
                    >
                        {rule.status === C.RULE_TYPE_EXPIRED
                            ? 'Publish'
                            : 'Expire'}
                    </Button>

                    <Button
                        className={`delete-rule ${
                            rule.status === C.RULE_TYPE_PUBLISHED
                                ? 'inactive'
                                : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleDelete(rule)}
                        disabled={
                            rule.status === C.RULE_TYPE_PUBLISHED ||
                            rule.status === C.RULE_TYPE_EXPIRED
                        }
                    >
                        Delete
                    </Button>
                    <Button
                        className={`save-rule ${
                            rule.status !== C.RULE_TYPE_DRAFT
                                ? 'active'
                                : 'inactive'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => {
                            dispatch(setCurrentRuleId(rule?.nbaRuleId));
                            dispatch(setCurrentRuleName(rule?.ruleName));
                            navigate('/rule-run-history');
                        }}
                        disabled={rule.status === C.RULE_TYPE_DRAFT}
                    >
                        View Run History
                    </Button>
                </div>
            );
        } else {
            return '-';
        }
    };

    // const handleSearch = () => {
    //     if (!jsonSearch.trim()) {
    //         setRules(holdDataForSearch);
    //     } else {
    //         const filteredData = holdDataForSearch.filter((row) =>
    //             row['json']?.toLowerCase().includes(jsonSearch.toLowerCase())
    //         );
    //         setRules(filteredData);
    //     }
    // };

    const renderField = (field) => {
        const commonHeader = <>{manageRulesTableHeader[field]}</>;

        if (field === 'json') {
            return (
                <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    {commonHeader}
                    {/* <div
                        className="search-container"
                        style={{ margin: '10px' }}
                    >
                        <input
                            type="text"
                            placeholder="Search"
                            className="search-box"
                            onChange={(e) => setJsonSearch(e.target.value)}
                        />
                        <SearchIcon
                            className="search-icon"
                            onClick={handleSearch}
                        />
                    </div> */}
                </Box>
            );
        }
        return commonHeader;
    };

    const dataFormatter =(row, cols)=>{
        const colVal = cols?.map((col, idx)=>{
            const field =col;
            return (
                field === 'ruleName' ? (
                    <TableCell
                        key={idx}
                        className="table-cell"
                        style={{
                            whiteSpace:
                                'normal',
                            wordBreak:
                                'break-word',
                            maxWidth: 250,
                            // textTransform: 'uppercase',
                        }}
                    >
                        {renderFieldContent(
                            field,
                            row
                        )}
                    </TableCell>
                ) : (
                    <TableCell
                        key={idx}
                        className="table-cell"
                    >
                        {renderFieldContent(
                            field,
                            row
                        )}
                    </TableCell>
                )
            )
        });
        return colVal;
    }
    return (
        <div className="component-container-root">
            <SideNav
                closeRuleEditor={closeRuleEditor}
                openRuleEditor={openRuleEditor}
            />
            {showRuleEditor ? (
                <RuleEditor
                    status={showRuleEditor}
                    type={type}
                    ruleId={ruleId}
                    onClose={closeRuleEditor}
                    origin={C.RULE_EDITOR_MANAGE_PROGRAM}
                />
            ) : (
                <Box className="manage-rules-container component-container">
                    <p className="instruction">
                        View and manage the rules of the NBA program. Go to '
                        <Link to="/help">Help page</Link>' for information on
                        how to manage.
                    </p>
                    <div
                        className="manage-rules"
                        style={{ textWrap: 'nowrap' }}
                    >
                        <CustomMuiTable headerColumns={manageRulesTableHeader} rows={rules} dataFormatter={dataFormatter} filterColumns={filterColumns} sortingColumns={filterColumns} defaultSortField={"nbaRuleId"} defaultSortOrder={"desc"} />
                        <div className="table-footer">
                                <button
                                    className="add-rule"
                                    onClick={() =>
                                        openRuleEditor(C.RULE_TYPE_NEW)
                                    }
                                >
                                    + Add Rule
                                </button>
                            </div>
                        
                    </div>
                </Box>
            )}
            {confirmDialog.display && (
                <ConfirmDialog
                    title={confirmDialog.title}
                    message={confirmDialog.message}
                    note={confirmDialog.note}
                    onClose={confirmDialog.onClose}
                    onConfirm={confirmDialog.onConfirm}
                    confirmText={confirmDialog.confirmText}
                    backText={confirmDialog.backText}
                />
            )}
        </div>
    );
};

export default ManageRules;
